<template>
    <div class="loading-wrap">
        <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'loading',
}

</script>

<style lang="scss">
    $size: 4rem;

    .loading-wrap {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: rgba(#000000, 0);
        z-index: 99999999999999999999999999999999;
        pointer-events: none;

        &.static {
            position: relative;
            height: auto;

            .lds-spinner {
                display: block;
                position: relative;
                left: auto;
                bottom: auto;
                opacity: .5;
                margin: var(--padding-x3) auto;
                padding: var(--padding-x3);
            }

            .lds-spinner div:after {
                background: #000;
            }
        }

        &.absolute {
            position: absolute;
            height: auto;

            .lds-spinner {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                bottom: auto;
                opacity: .5;
                margin: 0;
                padding: 0;
                transform: scale(.5) translate(-100%, 0%);
            }

            .lds-spinner div:after {
                background: #000;
            }
        }
    }

    .lds-spinner {
        color: official;
        display: inline-block;
        position: absolute;
        width: $size;
        height: $size;
        left: var(--padding);
        bottom: var(--padding);
        // transform: scale(.5);
        opacity: .5;
    }

    .lds-spinner div {
        transform-origin: $size/2 $size/2;
        animation: lds-spinner 1.2s linear infinite;
    }

    .lds-spinner div:after {
        content: " ";
        display: block;
        position: absolute;
        top: $size * 0.0375;
        left: $size * 0.4625;
        width: $size * 0.075;
        height: $size * 0.225;
        border-radius: 20%;
        background: #fff;
    }

    .lds-spinner div:nth-child(1) {
        transform: rotate(0deg);
        animation-delay: -1.1s;
    }

    .lds-spinner div:nth-child(2) {
        transform: rotate(30deg);
        animation-delay: -1s;
    }

    .lds-spinner div:nth-child(3) {
        transform: rotate(60deg);
        animation-delay: -0.9s;
    }

    .lds-spinner div:nth-child(4) {
        transform: rotate(90deg);
        animation-delay: -0.8s;
    }
    .lds-spinner div:nth-child(5) {
        transform: rotate(120deg);
        animation-delay: -0.7s;
    }
    .lds-spinner div:nth-child(6) {
        transform: rotate(150deg);
        animation-delay: -0.6s;
    }
    .lds-spinner div:nth-child(7) {
        transform: rotate(180deg);
        animation-delay: -0.5s;
    }
    .lds-spinner div:nth-child(8) {
        transform: rotate(210deg);
        animation-delay: -0.4s;
    }
    .lds-spinner div:nth-child(9) {
        transform: rotate(240deg);
        animation-delay: -0.3s;
    }
    .lds-spinner div:nth-child(10) {
        transform: rotate(270deg);
        animation-delay: -0.2s;
    }
    .lds-spinner div:nth-child(11) {
        transform: rotate(300deg);
        animation-delay: -0.1s;
    }
    .lds-spinner div:nth-child(12) {
        transform: rotate(330deg);
        animation-delay: 0s;
    }

     @keyframes lds-spinner {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

</style>
